import { SnapQuoteStatus } from '@snap-types/models/snap-quote/enums';

/**
 * SnapQuotes that have been deleted are ineligible to edit. All other statuses
 * are eligible to edit (create a new `SnapQuoteVersion` for).
 */
export const ImmutableSnapQuoteStatuses = [SnapQuoteStatus.DELETED] as string[];
